<p>
  Logging out user
</p>
<iframe id="iframeportalhidden" style="width:1px; border: 0px; height:1px;" [src]="hiddenPortalSrc" title="Hidden Portal"></iframe>
<iframe id="iframeindicatorhidden" style="width:1px; border: 0px; height:1px;" [src]="hiddenIndicatorSrc" title="Hidden Indicator"></iframe>
